import NotificationDot from 'components/NotificationDot/NotificationDot';
import withNotificationDotProps from 'viewModel/NotificationDot/withNotificationDotProps';

export default withNotificationDotProps(NotificationDot);
